import { render, staticRenderFns } from "./registrationsBulkStudenTransfer.vue?vue&type=template&id=59c3251c"
import script from "./registrationsBulkStudenTransfer.vue?vue&type=script&lang=js"
export * from "./registrationsBulkStudenTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports